import {
  Stack,
  Card,
  CardContent,
  Typography,
  Box,
} from '@mui/material';
import { fLargeNumber } from '../../../../utils/formatNumber';

function InfoCard(props) {
  const {
    title,
    subtitle,
    value,
    footerLabel,
    footerValue,
  } = props;
  return (
    <Card sx={{ flex: 1, borderRadius: 2 }}>
      <CardContent>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-start"
        >
          <Box>
            <Typography variant="subtitle2" color="text.secondary">
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="subtitle2" color="text.secondary">
                (
                {subtitle}
                )
              </Typography>
            )}
          </Box>
          <Typography
            variant="h4"
            fontWeight={600}
            noWrap
            sx={{ textAlign: 'right' }}
          >
            {value}
          </Typography>
        </Stack>

        {footerLabel && (
          <Stack direction="row" mt={1}>
            <Typography variant="body2" color="text.secondary">
              {footerLabel}
            </Typography>
            {footerValue !== null && footerValue !== undefined && (
              <Typography variant="body2" color="text.secondary">
                :
                {' '}
                <strong>{footerValue}</strong>
              </Typography>
            )}
          </Stack>
        )}
      </CardContent>
    </Card>
  );
}

export default function FeatureUsageInfoCard(props) {
  const {
    siteWideLicense,
    totalActiveSeats,
    userPercent,
    accountCount,
    totalActiveAccounts,
    userLastDate,
    operationLastDate,
    lastAvailableMonthUserCount,
    lastAvailableMonthOperationCount,
  } = props;

  const adjustedUserPercent = Math.min(userPercent, 100);
  const operationsPerUser = lastAvailableMonthUserCount > 0 ? (Math.round(lastAvailableMonthOperationCount / lastAvailableMonthUserCount)) : 0;

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{ width: '100%' }}
    >
      {/* Accounts */}
      <InfoCard
        title="Accounts"
        subtitle="Used"
        value={accountCount}
        footerLabel="Not Used"
        footerValue={totalActiveAccounts - accountCount}
      />

      {/* Users */}
      <InfoCard
        title="Users"
        subtitle={userLastDate}
        value={fLargeNumber(lastAvailableMonthUserCount)}
        footerLabel={!siteWideLicense && totalActiveSeats > 0 ? 'Percentage of Total Seats' : null}
        footerValue={`${adjustedUserPercent}%`}
      />

      {/* Operations */}
      <InfoCard
        title="Operations"
        subtitle={operationLastDate}
        value={fLargeNumber(lastAvailableMonthOperationCount)}
        footerLabel="Operations per User"
        footerValue={fLargeNumber(operationsPerUser)}
      />
    </Stack>
  );
}
